import { UIView, type UIViewInjectedProps } from '@uirouter/react';
import { Layout as AntdLayout } from 'antd';
import { useState } from 'react';

import { Header } from '@/components';
import { Menu } from '@/components/menu';
import { menuItems } from '@/constants/menu';

const { Content } = AntdLayout;

export const Layout = ({ transition }: UIViewInjectedProps) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggle = () => {
    setCollapsed((prevCollapsed: boolean) => !prevCollapsed);
  };

  return (
    <AntdLayout className="main-layout">
      <Header collapsed={collapsed} toggle={toggle} />
      <AntdLayout>
        <Menu collapsed={collapsed} transition={transition} menuItems={menuItems} />
        <Content className="content">
          <UIView />
        </Content>
      </AntdLayout>
    </AntdLayout>
  );
};

export const states = [
  {
    name: 'base-layout',
    component: Layout,
    data: {
      requiresAuth: true,
    },
  },
];
